import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  fetchAiPrompts as fetchAiPromptsRequest,
  updateAiPrompt as updateAiPromptRequest
} from 'services/api/ai';

import { IAiState, UpdateAiPromptParams } from './types';

export const fetchAiPrompts = createAsyncThunk('ai/fetchAiPrompts', async () =>
  fetchAiPromptsRequest()
);

export const updateAiPrompt = createAsyncThunk(
  'ai/updateAiPrompt',
  async (params: UpdateAiPromptParams) => {
    await updateAiPromptRequest(params.id, params.message, params.type);

    return params;
  }
);

const initialState: IAiState = {
  prompts: {
    loading: false,
    data: []
  }
};

const aiSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAiPrompts.pending, state => {
      state.prompts.loading = true;
    });
    builder.addCase(fetchAiPrompts.fulfilled, (state, action) => {
      state.prompts.loading = false;
      state.prompts.data = action.payload;
    });
    builder.addCase(fetchAiPrompts.rejected, state => {
      state.prompts.loading = false;
      state.prompts.data = [];
    });
    builder.addCase(updateAiPrompt.fulfilled, (state, action) => {
      const index = state.prompts.data.findIndex(
        item => item.id === action.payload.id
      );

      if (index !== -1) {
        state.prompts.data[index].message = action.payload.message;

        if (action.payload.type) {
          state.prompts.data[index].type = action.payload.type;
        }
      }
    });
  }
});

export default aiSlice.reducer;
